var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-box"},[_c('div',{staticClass:"inner"},[_vm._t("default")],2),_c('img',{staticClass:"tag-bg tag-left",attrs:{"src":require("../assets/tonghong/tag_left.png")}}),_c('img',{staticClass:"tag-bg tag-right",attrs:{"src":require("../assets/tonghong/tag_right.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }